/**
 * Takeoff (App Library) layout config.
 * Tweak these to retune the grid + icon sizing without hunting through Takeoff.tsx.
 *
 * Sizing model: the grid is a fixed COLS × ROWS per page. Cell size, icon size,
 * and label size are derived at runtime from the available container so the
 * grid fills the viewport (macOS Launchpad style) and reflows on resize.
 */

/** Columns per page. */
export const GRID_COLS = 7;
/** Rows per page (fixed; total icons-per-page = COLS × ROWS). */
export const GRID_ROWS = 5;

/**
 * Horizontal padding around the grid as a fraction of the container width
 * (each side). 0.15 = 15% left + 15% right, leaving 70% for the columns.
 */
export const GRID_PADDING_X_RATIO = 0.15;
/** Vertical padding around the grid (px each side, inside the pages region). */
export const GRID_PADDING_Y = 32;
/** Gap between columns (px). */
export const GRID_GAP_COL = 12;
/** Gap between rows (px). */
export const GRID_GAP_ROW = 12;

/** Fraction of the cell's smaller dimension used for the square icon tile. */
export const ICON_SIZE_RATIO = 0.76;
/** Fraction of icon size used for emoji/text glyph. */
export const ICON_FONT_RATIO = 0.62;
/** Border radius is this fraction of icon size. */
export const ICON_RADIUS_RATIO = 0.22;

/** Hard bounds on icon size so layouts don't go absurd at extreme viewports. */
export const ICON_MIN_PX = 72;
export const ICON_MAX_PX = 240;

/** Label sits below the icon — sized as a fraction of icon size, then clamped. */
export const LABEL_FONT_RATIO = 0.16;
export const LABEL_FONT_MIN_PX = 11;
export const LABEL_FONT_MAX_PX = 18;
/** Vertical gap between icon and label (fraction of icon size). */
export const LABEL_GAP_RATIO = 0.03;
